import React from "react";
import { Button, ButtonToolbar, Modal } from "react-bootstrap";

function AddNewStateModal({
  isLoadingAddNewState,
  countryList,
  isAddNewStateModal,
  handleAddNewStateHide,
  formik,
  handleOnClickOfAddNewStateCancelButton,
}) {
  return (
    <>
      <Modal
        show={isAddNewStateModal}
        onHide={handleAddNewStateHide}
        dialogClassName="modal-90w"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        closeButton
      >
        <Modal.Header closeButton>
          <Modal.Title> {`Add New State`}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-0">
          <form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
            <div className="row">
              <div className="col-md-6 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`State Name`}
                </h5>
                <input
                  type="text"
                  className="form-control form-control-solid form-control-solid-brand h-40px"
                  placeholder={`State Name`}
                  name="state_name"
                  {...formik.getFieldProps("state_name")}
                />
                {formik.touched.state_name && formik.errors.state_name ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.state_name}
                  </div>
                ) : null}
              </div>
              <div className="col-md-6 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`State Code`}
                </h5>
                <input
                  type="text"
                  className="form-control form-control-solid form-control-solid-brand h-40px"
                  placeholder={`State Code i.e 'CA'`}
                  name="state_code"
                  {...formik.getFieldProps("state_code")}
                />
                {formik.touched.state_code && formik.errors.state_code ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.state_code}
                  </div>
                ) : null}
              </div>
              <div className="col-md-6 mb-4 d-none">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`Select Status`}
                </h5>
                <select
                  className="form-control form-control-solid form-control-solid-brand h-40px is-valid-select"
                  name="status"
                  {...formik.getFieldProps("status")}
                >
                  <option value="1">Active</option>
                  <option value="0">Deactive</option>
                </select>
                {formik.touched.status && formik.errors.status ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.status}
                  </div>
                ) : null}
              </div>

              <div className="col-md-6 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`Select Country`}
                </h5>
                <select
                  className="form-control form-control-solid form-control-solid-brand h-40px is-valid-select"
                  name="countryname"
                  {...formik.getFieldProps("countryname")}
                >
                  {countryList.map((country, index) => (
                    <option value={country.name} key={index}>
                      {country.name}
                    </option>
                  ))}
                </select>
                {formik.touched.countryname && formik.errors.countryname ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.countryname}
                  </div>
                ) : null}
              </div>
            </div>
            <ButtonToolbar className="d-flex justify-content-end button-wrap mb-8 mt-8">
              <Button
                variant="btn btn-success mr-3"
                type="submit"
                disabled={formik.isSubmitting}
              >
                {`Add`}
                {isLoadingAddNewState && (
                  <span className=" mr-3 ml-3 spinner spinner-white"></span>
                )}
              </Button>
              <Button
                type="reset"
                variant="btn btn-light-dark"
                onClick={handleOnClickOfAddNewStateCancelButton}
              >
                {`Cancel`}
              </Button>
            </ButtonToolbar>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default AddNewStateModal;
